<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title :title="historyTitle"></pt-page-title>
    <!-- <div v-if="queryName === 'lab_export' || queryName === 'lab_order_export' || queryName === 'lab_rawdata_export' || queryName === 'lab_sample_plate_assign_export' || queryName === 'import_record'">
      <pt-page-menu-filter :tabs="showTypeTabs" v-model="selectTab" state="name" :class="$style.menufilter" :isRouteQuery="true"></pt-page-menu-filter>
    </div> -->
    <pt-export-history-table :tableLabels="tableLabels" :page-size="pageSize" :queryName="queryName" ref="table">
      <el-table-column label="操作" v-if="queryName === 'import_record'" width="300px">
        <template slot-scope="scope">
          <el-button type="text" v-if="scope.row.countSuccess!==0" @click="toOrderList(scope.row.id)">成功创建订单列表</el-button>
          <el-button type="text" v-if="scope.row">
            <a :href="$privateResourcesUrlDownload + scope.row.sourceFileUrl" style="text-decoration:none">样品接收单原文件</a>
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" v-else>
        <template slot-scope="scope">
          <el-button type="text" v-if="scope.row.state==='STORED'" @click="download(scope.row)">下载</el-button>
          <el-button type="text" @click="toDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </pt-export-history-table>
  </div>
</template>

<script>
// 组件class前缀
import ptExportHistoryTable from './pt-export-history-table/withData'
import { historyTableLabels, historyInTableLabels, historyInTableLabelsOfImport } from './export-history-option'
import request from 'utils/request'
const prefixCls = 'pt-export-history'
export default {
  name: 'pt-export-history',
  components: {
    ptExportHistoryTable
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    apiServer () {
      return this.$store.state.saasConfig.currentApiServer
    },
    isImport () {
      return this.$route.query.isImport === 'true'
    },
    isDownload(){
      return this.$route.query.isDownload==='true'
    },
    historyTitle () {
      let pageName
      switch (this.queryName) {
        case 'lab_sample_plate_assign_export': pageName = '排版表导出历史'
          break
        case 'mall_order_export': pageName = '订单导出历史'
          break
        case 'refund': pageName = '退款订单导出历史'
          break
        case 'lab_export': pageName = '导出/导入历史'
          break
        case 'lab_order_export': pageName = '样品导出历史'
          break
        case 'lab_rawdata_export': pageName = '下机数据导出历史'
          break
        case 'import_record': pageName = '样品接收单导入记录'
          break
        case 'stock_in_export': pageName = '入库单导出历史'
          break
        case 'stock_out_export': pageName = '出库单导出历史'
          break
        case 'production_task_export': pageName = '生产任务单导出历史'
          break
        case 'material_inventory_export': pageName = '库存单导出历史'
          break
        case 'lab_chip_slot_assign_export': pageName = '导出历史'
          break
        case 'lab_bill_pdf_download':pageName = '委托单下载历史'
          break
        case 'lab_bill_word_download': pageName = '报告下载历史'
          break
        case 'lab_bill_export':pageName = '委托单导出历史'
          break
        case 'billbatch':pageName = '委托单导入历史'
          break
        case 'batch':pageName = '样品导入历史'
          break
        case 'lab_production_task_export':pageName = '生产任务导出历史'
          break
        case 'lab_task_order_download':pageName='生产任务下载历史'
          break
        case 'lab_bill_item_mr': pageName = '核磁表格下载历史'
          break
        case 'lab_bill_in_out_record': pageName = '出入库表格下载历史'
          break
        default: pageName = null
      }
      return pageName
      //   return this.queryName === 'order' ? '订单导出历史' : (this.queryName === 'refund' ? '退款订单导出历史' : 'null')
    },
    service () {
      let service
      switch (this.queryName) {
        case 'lab_export': service = 'lab'
          break
        case 'lab_order_export': service = 'lab'
          break
        case 'lab_rawdata_export': service = 'lab'
          break
        case 'stock_in_export': service = 'lab'
          break
        case 'stock_out_export': service = 'lab'
          break
        case 'production_task_export': service = 'lab'
          break
        case 'material_inventory_export': service = 'lab'
          break
        case 'lab_chip_slot_assign_export': service = 'lab'
          break
        case 'import_record': service = 'lab'
          break
        case 'lab_bill_export': service = 'lab'
          break
        case 'lab_production_task_export':service = 'lab'
          break
        default: service = 'mallsales'
      }
      return service
    },
    tableLabels () {
      return this.isImport ? historyInTableLabelsOfImport : (this.queryName === 'import_record' ? historyInTableLabels : historyTableLabels)
    },
    showTypeTabs () {
      return this.typeTabs
    },
    isUCAS () {
      return this.$store.state.saasConfig.tenant === 'ucas'
    }
  },
  data () {
    return {
      pageSize: 10,
      queryName: '',
      typeTabs: [
        {
          label: '排版表导出历史',
          value: 'lab_sample_plate_assign_export'
        },
        // {
        //   label: '报告导出历史',
        //   value: 'lab_export'
        // },
        {
          label: '订单导出历史',
          value: 'lab_order_export'
        },
        {
          label: '下机数据导出历史',
          value: 'lab_rawdata_export'
        },
        {
          label: '样品接收单导入记录',
          value: 'import_record'
        }
      ],
      isUcasTypeTabs: [{
        label: '排版表导出历史',
        value: 'lab_sample_plate_assign_export'
      },
      {
        label: '订单导出历史',
        value: 'lab_order_export'
      },
      {
        label: '样品接收单导入记录',
        value: 'import_record'
      }],
      selectTab: '',
      loading: false
    }
  },
  watch: {
    selectTab (val) {
      this.queryName = val
    }
  },
  methods: {
    download (row) {
      let downloadFileArr = [
        'lab_bill_pdf_download',
        'lab_task_order_download',
        'lab_bill_word_download',
        'lab_bill_item_mr',
        'lab_bill_in_out_record'
      ]
      let apiServer = (this.apiServer.substr(this.apiServer.length - 1, 1) === '/') ? this.apiServer : this.apiServer + '/'
      if (this.queryName === 'lab_sample_plate_assign_export') {
        location.href = `${apiServer}lab/api/user/oss/items/download/${row.id}`
      } else {
        if (downloadFileArr.includes(this.queryName)) {
          location.href = `${this.$privateResourcesUrlDownload}${row.path}`
          return
        }
        location.href = `${apiServer}${this.service}/api/user/oss/items/download/${row.id}`
        // location.href=`${this.$privateResourcesUrlDownload}${row.path}`
      }
    },
    toOrderList (id) {
      this.$router.push({ path: `/gene-lab-order?targetStatus=ALL&page=1&jobRecordId=${id}` })
    },
    toDelete (row) {
      this.$confirm('确定要删除此导出历史吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        let api=this.isImport?'DeleteLabOrderHistory':'deleteDownloadHistory'
        this.$store.dispatch(api, row.id).then(res => {
          this.$refs.table.reload()
          this.$message.success('删除成功!')
          this.loading = false
        }).catch(err => {
          this.loading = false
          console.error(err)
          this.$message.error(err)
        })
      })
    }
  },
  created () {
    this.queryName = this.$route.query.name
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
// .menufilter{
//   margin-left: 2rem
// }
</style>
